import { Action } from '@ngrx/store';
import { ActionOptionsArgs, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { Control } from './control.model';

export const ENTITY = 'control';
export const SUBMIT = '[Control] Submit';
export const REHYDRATE = '[Control] Rehydrate';
export const REMOVE = '[Control] Remove';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: Control, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<Control>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = REMOVE;

    constructor(public payload: Control, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction;



// WEBPACK FOOTER //
// ./src/vas/business-objects/control/control.actions.ts